import { render, staticRenderFns } from "./regTypesAccessForm.vue?vue&type=template&id=55d7cf80"
import script from "./regTypesAccessForm.vue?vue&type=script&lang=js"
export * from "./regTypesAccessForm.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports